export default "__VITE_ASSET__736c0e32__"